import request from '@utils/request'
import { ReturnType } from './types'

const getAllDashboardCount = async (state: string, params: any) => {
  try {
    const config: ReturnType = {
      url: 'dashboard',
      method: 'get',
      params,
      authorization: true,
      config: {
        showErr: true,
        store: {
          action: 'set',
          key: state,
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}
export default {
  getAllDashboardCount,
}
